/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
export type GetCategoryProductsQueryVariables = Types.Exact<{
  input: Types.GetContentCategoryProductsInput;
}>;


export type GetCategoryProductsQuery = { __typename?: 'Query', getCategoryProducts: { __typename?: 'GetContentCategoryProductsResponse', totalCount?: number | null, pageDescription?: string | null, footerDescription: string, error?: { __typename?: 'ErrorGrowth', description?: string | null } | null, seo?: { __typename?: 'SEOData', title?: string | null, description?: string | null, image?: string | null } | null, pagination: { __typename?: 'CategoryPagination', currentPage: number, pageSize: number, totalPages: number, totalItems: number, pageTitle?: string | null }, products: Array<{ __typename?: 'ProductBox', productId?: number | null, productTitle?: string | null, productUrl?: string | null, productImage?: string | null, productCountdown?: string | null, productCountdownText?: string | null, categoryUrl?: string | null, favorites?: number | null, imageAlt?: string | null, productTitleLocalized?: { __typename?: 'LocalizedStrings', en?: string | null, es?: string | null, de?: string | null, pt?: string | null, fr?: string | null, it?: string | null, nl?: string | null, pl?: string | null } | null, cardCategory?: { __typename?: 'LocalizedStrings', en?: string | null, es?: string | null, de?: string | null, pt?: string | null, fr?: string | null, it?: string | null, nl?: string | null, pl?: string | null } | null, designer?: { __typename?: 'DesignerProfile', designerId?: number | null, designerName?: string | null, designerUrl?: string | null, designerAvatar?: string | null, isPremium?: boolean | null, premiumLegalEntity?: string | null } | null, classProperties?: { __typename?: 'ClassProperties', level?: string | null, source?: string | null } | null }>, categories: Array<{ __typename?: 'CategoryLink', name: string, slug: string, imageUrl?: string | null }>, breadcrumbs?: Array<{ __typename?: 'Breadcrumb', name?: string | null, slug?: string | null }> | null, faqSection?: Array<{ __typename?: 'CategoryFAQ', question: string, answer: string }> | null, articleSection?: { __typename?: 'FontArticleSection', articles: Array<{ __typename?: 'FontArticle', title: string, intro: string, imageUrl: string, url: string }> } | null } };


export const GetCategoryProductsDocument = `
query GetCategoryProducts($input: GetContentCategoryProductsInput!) {
  getCategoryProducts(input: $input) {
    error {
      description
    }
    totalCount
    pageDescription
    seo {
      title
      description
      image
    }
    pagination {
      currentPage
      pageSize
      totalPages
      totalItems
      pageTitle
    }
    products {
      productId
      productTitle
      productUrl
      productImage
      productCountdown
      productCountdownText
      categoryUrl
      favorites
      imageAlt
      productTitleLocalized {
        en
        es
        de
        pt
        fr
        it
        nl
        pl
      }
      cardCategory {
        en
        es
        de
        pt
        fr
        it
        nl
        pl
      }
      designer {
        designerId
        designerName
        designerUrl
        designerAvatar
        isPremium
        premiumLegalEntity
      }
      classProperties {
        level
        source
      }
    }
    categories {
      name
      slug
      imageUrl
    }
    breadcrumbs {
      name
      slug
    }
    faqSection {
      question
      answer
    }
    articleSection {
      articles {
        title
        intro
        imageUrl
        url
      }
    }
    footerDescription
  }
}

`

export const GetCategoryProductsQueryRootKey = 'GetCategoryProducts'

export function GetCategoryProductsQueryFetcher(variables: GetCategoryProductsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<GetCategoryProductsQuery, GetCategoryProductsQueryVariables>(GetCategoryProductsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function GetCategoryProductsQueryKey(variables: GetCategoryProductsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [GetCategoryProductsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function GetCategoryProductsQueryOptions(
    variables: GetCategoryProductsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<GetCategoryProductsQuery, unknown, GetCategoryProductsQuery, (GetCategoryProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: GetCategoryProductsQueryKey(variables, fetchOptions),
        queryFn: GetCategoryProductsQueryFetcher(variables, fetchOptions),
    }
}

export function useGetCategoryProductsQuery<D = GetCategoryProductsQuery, E = unknown>(
    variables: GetCategoryProductsQueryVariables,
    options?: Omit<UseQueryOptions<GetCategoryProductsQuery, E, D, (GetCategoryProductsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<GetCategoryProductsQuery, E, D, (GetCategoryProductsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...GetCategoryProductsQueryOptions(variables, fetchOptions),
    })
}